import React, { createContext, useState, useEffect, useCallback, useRef } from 'react';
import { ingestionQueues } from './service';
import { isUserLoggedIn, showJobQueueNotificationIcon } from '../../../shared/services/shared';

export const JobQueueContext = createContext();
const POLL_INTERVAL = 30000;

export const JobQueueProvider = ({ children }) => {
  const [runningJobCount, setRunningJobCount] = useState(0);
  const [jobQueueModalOpen, setJobQueueModalOpen] = useState(false);
  const isLoggedIn = isUserLoggedIn();
  const showNotificationIcon = showJobQueueNotificationIcon();
  const pollTimerRef = useRef(null); // Persistent ref

  const fetchAndSetRunningJobs = useCallback(async () => {
    try {
      const resp = await ingestionQueues();
      const jobs = Array.isArray(resp.data) ? resp.data : [];
      const running = jobs.filter(job => job.status === 'In Progress');
      setRunningJobCount(running.length);
    } catch (error) {
      console.error('Failed to fetch job queue:', error);
      setRunningJobCount(0);
    }
  }, []);

  useEffect(() => {
    //Set interval only if logged in and flag is enabled
    if (isLoggedIn && showNotificationIcon) {
      fetchAndSetRunningJobs(); // Initial call

      pollTimerRef.current = setInterval(fetchAndSetRunningJobs, POLL_INTERVAL);
    }

    //Cleanup on unmount or login state change
    return () => {
      if (pollTimerRef.current) {
        clearInterval(pollTimerRef.current);
        pollTimerRef.current = null;
      }
    };
  }, [fetchAndSetRunningJobs, isLoggedIn, showNotificationIcon]);

  return (
    <JobQueueContext.Provider
      value={{
        runningJobCount,
        setRunningJobCount,
        refreshRunningJobs: fetchAndSetRunningJobs,
        jobQueueModalOpen,
        setJobQueueModalOpen,
      }}
    >
      {children}
    </JobQueueContext.Provider>
  );
};
